
$(document).ready(function () {
    //SIGN IN COLLAPSE SCRIPT START
    $('#sign_in_wrap').on('show.bs.collapse', function () {
        $('body').addClass('signIn-collapse-open');
    });
    $('#sign_in_wrap').on('hide.bs.collapse', function () {
        $('body').removeClass('signIn-collapse-open');
    });
    //SIGN IN COLLAPSE SCRIPT END
    $('#filter-collapse').on('show.bs.collapse', function () {
        // $('.form-item-field-completion-year-value .form-item-field-completion-year-af-value .form-select').multiselect('refresh');
        // $('.form-item-field-start-year-value .form-item-field-start-year-af-value .form-select').multiselect('refresh');
        $('.form-item-field-awards-target-id .form-select').multiselect('refresh');
        // $('.form-item-field-knowledge-completion-year-value .form-select').multiselect('refresh');
        // $('.form-item-field-year-of-publication-value .form-select').multiselect('refresh');
        $('.form-item-field-resource-city-target-id .form-select').multiselect('refresh');
        $('.form-item-field-resource-location-country .form-select').multiselect('refresh');
        $('.form-item-field-bp-location-country .form-select').multiselect('refresh');
        $('.form-item-field-regions-target-id .form-select').multiselect('refresh');
        $('.form-item-field-region-target-id .form-select').multiselect('refresh');
        $('.form-item-field-sub-type-target-id .form-select').multiselect('refresh');
        $('.form-item-field-resource-type-target-id .form-select').multiselect('refresh');
        $('.form-item-field-type-of-organization-target-id  .form-select').multiselect('refresh');
        $('.form-item-field-resource-themes-target-id  .form-select').multiselect('refresh');
        $('.form-item-field-themes-target-id .form-select').multiselect('refresh');
        $('.form-item-field-new-urban-agenda-principle-target-id .form-select').multiselect('refresh');
        $('.form-item-field-resource-goals-target-id .form-select').multiselect('refresh');
        $('.form-item-field-sustainable-development-go-target-id .form-select').multiselect('refresh');
    })
});
